import { Dispatch } from 'redux';
import { SAVE_ATR } from './types';

interface Payload {
  answer: {
    id: string;
    text: string;
  };
  id: string;
  question: string;
}

function saveAtr(payload: Payload) {
  return function action(dispatch: Dispatch) {
    dispatch({
      payload,
      type: SAVE_ATR,
    });
  };
}

export default saveAtr;
